// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Footer__Heart":"Footer_Footer__Heart__v-X-z","Footer__Link":"Footer_Footer__Link__1qCNG"};